// extracted by mini-css-extract-plugin
export var certificateDisplay = "CertificateDisplay-module--certificateDisplay--koePT";
export var certificateContainer = "CertificateDisplay-module--certificateContainer--1Jgq7";
export var certificate = "CertificateDisplay-module--certificate--2tvDr";
export var svgWrapper = "CertificateDisplay-module--svgWrapper--1RfT4";